'use client';

const emphasisOptions = ["low", "medium"];
const sizeOptions = ["sm", "md"];
export {
  emphasisOptions,
  sizeOptions
};
